import { useState } from 'react';

/**
 * Custom React hook for managing zoom scale.
 *
 * @param {number} initialScale - The initial zoom scale value. Defaults to 1.0.
 * @returns {object} An object containing the current scale,
 *                   a function to zoom in, and a function to zoom out.
 */
export default function useZoom(initialScale = 1.0) {
    const [scale, setScale] = useState(initialScale);
    const handleZoomIn = () => setScale(prev => Math.min(prev + 0.1, 3));
    const handleZoomOut = () => setScale(prev => Math.max(prev - 0.1, 0.5));
    return { scale, handleZoomIn, handleZoomOut };
}